<script>
import { merchantComputed } from "@store/helpers";
import getISODay from "date-fns/getISODay";
import { cityAreaOptions, storeOptions } from "@utils/ipetbooking-options";
import formatDay from "@utils/format-day";
import { HOME_TIME_LIST } from "@src/config/reservation";


export default {
  components: {
    StoreSection: () => import("@components/Store/StoreSection"),
  },
  data() {
    return {
      tempSelectItem: {
        storeAlias: '',
      },
      toDayDay: getISODay(new Date()),
      show: true,
      activeTab: 'all',
      tabList: Object.freeze([
        {
          title: '全部地區',
          name: 'all',
        },
        ...cityAreaOptions().map(item => {
          return {
            title: item.text,
            name: item.value
          }
        })
      ]),
      homeTimeList: HOME_TIME_LIST
    }
  },
  computed: {
    ...merchantComputed,
    storeList() {
      return storeOptions({
        type: 'open',
        storeArea: this.activeTab,
        limit: 3
      })
    },
  },
  watch: {
    $globalBreakpoint: {
      handler() {
        this.show = false;
        setTimeout(() => {
          this.show = true;
        }, 30)
      },
      immediate: true,
    }
  },
  methods: {
    formatDay,
    getServiceTimeSetting(storeItem) {
      return storeItem.params.serviceTimeSetting['1']
    },
    addressRestrictionsText(storeItem) {
      return (storeItem?.params?.addressRestrictions || [])
        .map(item => item.city)
        .join(', ')
    },
    openDialogLine({
      storeTitle,
      lineId,
      lineFriendUrl
    }) {
      if(this.$globalIsMobileDevice && lineFriendUrl) {
        window.open(lineFriendUrl)
      } else {
        this.$globalDialog('DialogLine', {
          storeTitle,
          lineId,
          lineFriendUrl
        });
      }
    },
    goToReservation(storeAlias) {
      this.tempSelectItem = {
        storeAlias
      }
    },
    getDefaultImage(images) {
      const defaultImageItems = images.filter(image => image.default) || [];

      return defaultImageItems[0]?.path || '';
    },
    formatPhonenumber(phonenumber = '') {
      const [code, number] = phonenumber.split('-');

      return number
        ? phonenumber
        : ''
    },
    openDialogStoreJtails() {
      this.$globalDialog('DialogStore', {
        activeTab: 'store',
        isQuerySet: true,
      })
    }
  }
}
</script>
<!-- section template -->
<template>
  <section
    :class="[$style.sectionStore, { [$style.isStyleDingBeauty]: $globalIsDingBeauty }]"
    class="section"
    :data-store-length="storeList.length"
  >
    <div v-if="storeList.length > 1" class="section">
      <div class="container">
        <div class="sectionStore__head">
          <div class="sectionStore__headLeft">
            <BaseSectionTitleJtails
              title="分店資訊"
              :sub-title="$globalIsDingBeauty ? 'STORES' : 'stores'"
            />
          </div>
          <div class="sectionStore__headRight">
            <BaseTab
              v-if="tabList.length > 2"
              v-model="activeTab"
              :tab-list="tabList"
              name="storeArea"
              :is-stretch="true"
              type="jtailsStore"
            />
          </div>
        </div>
        <ul :class="[$style.storeList, { [$style.isStyleDingBeauty]: $globalIsDingBeauty }]" class="row">
          <template v-for="(storeItem, index) in storeList">
            <li
              :key="`stores-${index}`"
              :class="{ 'd-none d-md-block': index !== 0}"
              class="storeList__item col-md-4"
            >
              <div class="storeList__itemInner">
                <router-link
                  :to="{ name: 'store', params: { storeAlias: storeItem.alias } }"
                  class="storeList__imageBox"
                >
                  <div
                    class="storeList__image"
                    :style="{ backgroundImage: `url('${ getDefaultImage(storeItem.images) || require('@assets/images/default/store-default-Image@2x.png') }')` }"
                  ></div>
                </router-link>
                <div class="storeList__titleBox">
                  <h3>
                    <router-link
                      :to="{ name: 'store', params: { storeAlias: storeItem.alias } }"
                      class="storeList__title"
                    >
                      {{ storeItem.title }}
                    </router-link>
                  </h3>
                  <div class="storeList__socialBox">
                    <ul
                      v-if="!!storeItem.fbFanpageUrl || !!storeItem.lineFriendUrl"
                      :class="$style.socialList"
                    >
                      <li
                        v-if="!!storeItem.fbFanpageUrl"
                        class="socialList__item"
                      >
                        <BaseButton
                          class="isText3"
                          :class="{
                            'isStylePrimary': $globalIsJtails,
                            'isStyleSecondary': $globalIsDingBeauty,
                          }"
                          :href="storeItem.fbFanpageUrl"
                          target="_blank"
                        >
                          <i class="fontello fontello-facebook fa-2x"></i>
                        </BaseButton>
                      </li>
                      <li
                        v-if="!!storeItem.lineId || !!storeItem.lineFriendUrl"
                        class="socialList__item"
                      >
                        <template v-if="$globalIsMobileDevice">
                          <BaseButton
                            v-if="storeItem.lineFriendUrl"
                            class="isText3"
                            :class="{
                              'isStylePrimary': $globalIsJtails,
                              'isStyleSecondary': $globalIsDingBeauty,
                            }"
                            :href="storeItem.lineFriendUrl"
                            target="_blank"
                          >
                            <i class="fontello fontello-line fa-2x"></i>
                          </BaseButton>
                        </template>
                        <template v-else>
                          <BaseButton
                            class="isText3"
                            :class="{
                              'isStylePrimary': $globalIsJtails,
                              'isStyleSecondary': $globalIsDingBeauty,
                            }"
                            @click="openDialogLine({ storeTitle: storeItem.title, lineId: storeItem.lineId, lineFriendUrl: storeItem.lineFriendUrl })"
                          >
                            <i class="fontello fontello-line fa-2x"></i>
                          </BaseButton>
                        </template>
                      </li>
                    </ul>
                  </div>
                </div>
                <el-tag
                  v-if="$globalIsJtails"
                  class="isStylePrimary isSmall2 mr-2"
                >
                  寵物美容
                </el-tag>
                <hr class="storeList__hr">
                <ul :class="[$style.metaList]" >
                  <li
                    v-if="!!formatPhonenumber(storeItem.phoneNumber)"
                    class="metaList__item"
                  >
                    <a
                      :href="`tel:${ formatPhonenumber(storeItem.phoneNumber) }`"
                      class="metaList__link"
                    >
                      <i class="metaList__icon fontello fontello-phone fa-fw"></i>
                      <span class="metaList__text">{{ formatPhonenumber(storeItem.phoneNumber) }}</span>
                    </a>
                  </li>
                  <template v-if="!storeItem.storeType || storeItem.storeType === 'store'">
                    <li
                      v-if="!!storeItem.fullAddress"
                      class="col-12 metaList__item"
                    >
                      <a
                        :href="`https://www.google.com.tw/maps/search/${ storeItem.fullAddress }`"
                        class="metaList__link"
                        target="_blank"
                      >
                        <i class="metaList__icon fontello fontello-locate fa-fw"></i>
                        <span class="metaList__text">{{ storeItem.fullAddress }}</span>
                      </a>
                    </li>
                    <li
                      v-if="!!storeItem.params.serviceTimeSetting[toDayDay].start && !!storeItem.params.serviceTimeSetting[toDayDay].end"
                      class="metaList__item"
                    >
                      <el-popover
                        v-if="show"
                        placement="bottom-start"
                        :trigger="$globalBreakpoint === 'xs' || $globalBreakpoint === 'sm' || $globalBreakpoint === '2sm' || $globalBreakpoint === 'md' ? 'click' : 'hover'"
                        content=""
                      >
                        <div
                          slot="reference"
                          class="metaList__link"
                        >
                          <i class="metaList__icon fontello fontello-info fa-fw"></i>
                          <span class="metaList__text">
                            <span>今日</span>
                            <span
                              v-if="!!storeItem.params.serviceTimeSetting[toDayDay].isOpen"
                              class="font-number"
                            >營業時間
                              {{
                                storeItem.params.serviceTimeSetting[toDayDay].start
                              }}-{{ storeItem.params.serviceTimeSetting[toDayDay].end }}</span>
                          <span v-else>不營業</span>
                          </span>
                          <i class="fontello fontello-down fa-sm metaList__textIcon ml-1"></i>
                        </div>
                        <div>
                          <ul :class="$style.dayList">
                            <li
                              v-for="(dayItem, key, index2) in storeItem.params.serviceTimeSetting"
                              :key="index2"
                              class="dayList__item"
                              :class="{ isActive: toDayDay.toString() === key }"
                            >
                              <span class="dayList__title">{{ formatDay(key) }}</span>
                              <span
                                v-if="!!dayItem.isOpen"
                                class="dayList__time"
                              >{{
                                  storeItem.params.serviceTimeSetting[key].start
                                }}-{{ storeItem.params.serviceTimeSetting[key].end }}</span>
                              <span v-else>不營業</span>
                            </li>
                          </ul>
                        </div>
                      </el-popover>
                    </li>
                  </template>
                  <template v-if="storeItem.storeType === 'home'">
                    <li
                      v-if="!!storeItem.params.addressRestrictions[0]"
                      class="metaList__item"
                    >
                      <el-popover
                        v-if="show"
                        placement="bottom-start"
                        :trigger="$globalBreakpoint === 'xs' || $globalBreakpoint === 'sm' || $globalBreakpoint === '2sm' || $globalBreakpoint === 'md' ? 'click' : 'hover'"
                        content=""
                      >
                        <div
                          slot="reference"
                          class="metaList__link"
                        >
                          <i class="metaList__icon fontello fontello-locate fa-fw"></i>
                          <span class="metaList__text">
                            服務範圍 {{ addressRestrictionsText(storeItem) }}部分地區
                          </span>
                          <i class="fontello fontello-down fa-sm metaList__textIcon ml-1"></i>
                        </div>
                        <div>
                          <ul :class="$style.areaList">
                            <li
                              v-for="(areaItem, key, index2) in storeItem.params.addressRestrictions"
                              :key="index2"
                              class="areaList__item"
                              :class="{ isActive: toDayDay.toString() === key }"
                            >
                              <span class="areaList__title">{{ areaItem.city }}</span>
                              <span class="areaList__text">
                                {{ areaItem.district.join(', ') }}
                              </span>
                            </li>
                          </ul>
                        </div>
                      </el-popover>
                    </li>
                    <li
                      class="col-12 metaList__item"
                    >
                      <div
                        class="metaList__link"
                      >
                        <i class="metaList__icon fontello fontello-info fa-fw"></i>
                        <span class="metaList__text">
                          到府時段 {{ homeTimeList.join(' | ') }}
                        </span>
                      </div>
                    </li>
                  </template>
                </ul>
                <template v-if="!isSiteEnabled">
                  <BaseButton
                    class="isFull formReservationJtails__submit"
                    :class="{
                      'isStyleSecondary isRadius ': $globalIsJtails,
                      'isStyleDark': $globalIsDingBeauty,
                    }"
                    disabled
                  >
                    尚未開放預約
                  </BaseButton>
                </template>
                <BaseButton
                  v-else
                  class="isFull"
                  :class="{
                    'isStylePrimary isRadius': $globalIsJtails,
                    'isStyleSecondary isOutline': $globalIsDingBeauty,
                  }"
                  :to="{ name: 'store', params: { storeAlias: storeItem.alias } }"
                >
                  立即預約
                </BaseButton>
              </div>
            </li>
          </template>
        </ul>
        <BaseButton
          class=" isOutline2 isFull mt-3 d-md-none"
          :class="{
            'isStylePrimary isRadius': $globalIsJtails,
            'isStyleSecondary': $globalIsDingBeauty,
          }"
          @click="openDialogStoreJtails"
        >
          更多分店<i class="fontello fontello-angle-right ml-2"></i>
        </BaseButton>
      </div>
    </div>
    <template v-else>
      <StoreSection :store-item="storeList[0]" type="home"/>
    </template>
    <BasePre>currentMerchant.stores: {{ currentMerchant.stores }}</BasePre>
  </section>
</template>
<!-- section style -->
<style lang="scss" module>
.sectionStore {
  position: relative;

  &::before {
    position: absolute;
    top: -0.5rem;
    left: calc(((100vw - #{$container}) / 2) - 200px);
    width: 283px;
    height: 310px;
    content: "";
    background-image: url('@assets/images/layout/logo-jtails-small-green.svg');
    background-position: center;
    background-size: cover;
    opacity: 0.15;

    @media (max-width: #{$container + 450px}) {
      top: 2rem;
      left: 1rem;
      width: 226px;
      height: 248px;
    }

    @include max-md {
      display: none;
    }
  }
  &.isStyleDingBeauty {
    &::before {
      display: none;
    }
  }

  :global {
    .sectionStore {
      &__head {
        display: flex;
        align-items: center;
        justify-content: space-between;

        @include max-md {
          flex-direction: column;
        }
      }

      &__headLeft {
        @include unstyled;
      }

      &__headRight {
        @include max-md {
          width: 100%;
        }
      }
    }
  }
}

.storeList {
  @include list-unstyled;

  :global {
    .storeList {
      &__item {
        @include unstyled;
      }


      &__imageBox {
        position: relative;
        display: block;
        padding-top: 56.5%;
        margin-bottom: 1rem;
        overflow: hidden;
      }

      &__image {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: $color-bg-default;
        background-position: center;
        background-size: cover;
        transition: transform 0.3s;
        transform: scale(1);

        &:hover {
          transform: scale(1.15);
        }
      }

      &__titleBox {
        display: flex;
        align-items: center;
        justify-content: space-between;
        // margin-bottom: 0.5rem;
        // padding-bottom: 1rem;
        // border-bottom: 1px solid rgba($color-primary, 0.5);
        // margin-bottom: 1rem;
        min-height: 2.5rem;
      }

      &__hr {
        margin: 1rem 0;
        border-top: 1px solid $color-primary;
      }

      &__title {
        font-family: $font-serif;
        font-size: 1.25rem;
        font-weight: 600;
        line-height: 1.5;
        color: $color-primary-dark;
        letter-spacing: 0.15em;

        &:hover {
          color: $color-primary;
        }
      }

      &__socialBox {
        @include unstyled;
      }
    }
  }
  &.isStyleDingBeauty {
    :global {
      .storeList {
        &__hr {
          display: none;
        }
        &__title {
          color: $color-secondary;

          &:hover {
            color: $color-secondary-light;
          }
        }
      }
    }
  }
}

.socialList {
  @include list-unstyled;

  display: flex;
  align-items: center;
  justify-content: flex-end;

  @include max-lg {
    padding-top: 0;
    margin-bottom: 0;
    i {
      font-size: 2rem;
    }
  }

  :global {
    .socialList {
      &__item {
        font-size: 1rem;

        @include max-lg {
          margin-right: 1rem;
        }

        &:not(:first-child) {
          margin-left: 1rem;

          @include max-lg {
            margin-left: 0;
          }
        }
      }
    }

    .isText {
      color: $color-gray-2;
    }
  }
}

.metaList {
  @include list-unstyled;

  min-height: 5.5rem;
  margin-bottom: 2.5rem;
  line-height: 1.5;

  @include max-md {
    min-height: auto;
  }

  :global {
    .metaList {
      &__item {
        margin-bottom: 0.5rem;
        letter-spacing: 0.1em;
      }

      &__icon {
        padding-top: 0.15rem;
        margin-right: 0.5rem;
        color: $color-primary;
      }

      &__link {
        @include link-unstyled;

        display: inline-flex;
        font-size: 0.875rem;
        color: $color-gray-2;

        &[href] {
          &:hover, &:focus {
            color: $color-primary;

            .metaList {
              &__icon {
                color: $color-primary;
              }
            }
          }
        }
      }

      &__textIcon {
        color: $color-gray-3;
        transform: scale(0.8) translateY(5px);
      }

      &__text {
        @include unstyled;
      }
    }
  }
}

.areaList {
  @include list-unstyled;

  :global {
    .areaList {
      &__item {
        &:not(:last-child) {
          margin-bottom: 0.5rem;
        }
      }

      &__title {
        display: block;
        font-family: $font-serif;
        font-weight: 600;
        color: $color-primary-dark;
      }

      &__text {
        @include unstyled;
      }
    }
  }
}

.dayList {
  padding: 0.25rem 0;
  line-height: 2;

  @include list-unstyled;

  :global {
    .dayList {
      &__title {
        margin-right: 0.5rem;
        font-weight: 500;
      }

      &__time {
        font-family: $font-number;
        color: $color-gray-2;
      }

      &__item {
        padding: 0 0.5rem;

        &.isActive {
          color: $color-primary;

          .dayList {
            &__time {
              color: $color-primary;
            }
          }
        }
      }
    }
  }
}

</style>
